// extracted by mini-css-extract-plugin
export default {"backButton":"UserDetail_backButton__w3jtr"};